import React from 'react';
import { useAuth } from '../context/AuthContext';
import SearchPage from '../pages/SearchPage';
import LandingPage from '../pages/LandingPage';
import SubscribePage from '../pages/SubscribePage';

interface HomeRouterProps {
  onResultsChange?: (results: any) => void;
  onCompanyNameChange?: (name: string) => void;
  loadScreeningId?: number | null;
  onScreeningLoaded?: () => void;
  resetTrigger?: number;
}

const HomeRouter: React.FC<HomeRouterProps> = (props) => {
  const { loading, isAuthenticated, hasActiveSubscription, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (isAuthenticated && !hasActiveSubscription && !isAdmin) {
    return <SubscribePage />;
  }

  if (isAuthenticated) {
    return <SearchPage {...props} />;
  }

  return <LandingPage />;
};

export default HomeRouter;
